import React, { useEffect } from "react";

import useGlobalSearch from "hooks/useGlobalSearch";
import Tooltip from "components/tooltip";

import { SEARCH_TYPES, TITLE_MAX_LENGTH } from "../constants";
import styles from "./suggestedSearch.scss";

const {
    suggested_search,
    search_icon,
    list_container,
    search_list,
    search_text,
    search_content,
    ellipsis,
} = styles;

export default function SuggestedSearch({ handleSearchSelect }) {

    const { fetchSuggestedSearch, suggestedSearch: { contents: suggestedSearch } } = useGlobalSearch();

    useEffect(() => {
        fetchSuggestedSearch();
    }, []);

    return (
        <div className={suggested_search}>
            {suggestedSearch?.length > 0 && (
                <div className={list_container}>
                    <h4>Frequently Visited</h4>
                    <ul className={search_list}>
                        {suggestedSearch.map(search => {
                            const { id, title } = search;
                            return (
                                <li key={id}>
                                    <a href={search.handlerId} role="button" onClick={(event) => handleSearchSelect({ event, type: SEARCH_TYPES.SUGGESTED, search })}>
                                        <span className={search_icon}>
                                            <i className="aeh-icon-outlined-search-icon"></i>
                                        </span>
                                        <div className={search_content}>
                                            {title.length > TITLE_MAX_LENGTH ? <Tooltip
                                                parent={<p className={`${search_text} ${ellipsis}`}>{title}</p>}
                                                content={title}
                                            /> : <p className={`${search_text} ${ellipsis}`}>{title}</p>}
                                        </div>
                                    </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}
